import React from 'react';
import { Helmet } from 'react-helmet';
import FAQ from '../components/FAQ';
import FAQSchema from '../components/FAQSchema';
import BreadcrumbSchema from '../components/BreadcrumbSchema';

const FAQPage = () => {
  return (
    <>
      <Helmet>
        <title>Preguntas Frecuentes | GENSOL - Renta de Generadores Veracruz</title>
        <meta name="description" content="Resolvemos tus dudas sobre renta de generadores eléctricos. Información sobre tiempos de renta, zonas de servicio, instalación, mantenimiento y política de reemplazo." />
        <meta name="keywords" content="preguntas frecuentes generadores, FAQ renta equipos, política reemplazo, zonas servicio Veracruz" />
        <link rel="canonical" href="https://www.gensolver.com/faq" />
        <meta property="og:title" content="Preguntas Frecuentes | GENSOL" />
        <meta property="og:description" content="Todo lo que necesitas saber sobre nuestros servicios de renta de generadores." />
        <meta property="og:url" content="https://www.gensolver.com/faq" />
      </Helmet>

      {/* Structured Data: FAQ rich snippets + breadcrumbs */}
      <FAQSchema />
      <BreadcrumbSchema
        items={[
          { name: 'Inicio', url: 'https://www.gensolver.com/' },
          { name: 'Preguntas Frecuentes', url: 'https://www.gensolver.com/faq' },
        ]}
      />

      <main id="faq-page" data-page="faq" data-analytics-page="faq" className="pt-24">
        <FAQ />
        
        {/* Additional Help Section */}
        <section className="py-16 bg-gray-200">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              ¿Tienes más preguntas?
            </h2>
            <p className="text-gray-600 mb-8 max-w-xl mx-auto">
              Nuestro equipo está listo para ayudarte con cualquier duda sobre nuestros servicios
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:+522299212332"
                data-testid="faq-call-btn"
                data-analytics-click="faq-page-call"
                className="flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-gray-900 px-6 py-3 rounded-lg font-semibold transition-all"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                Llamar: 229 921 23 32
              </a>
              <a 
                href="https://wa.me/522292072733"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="faq-whatsapp-btn"
                data-analytics-click="faq-page-whatsapp"
                className="flex items-center justify-center gap-2 border-2 border-green-500 text-green-500 hover:bg-green-500 hover:text-gray-900 px-6 py-3 rounded-lg font-semibold transition-all"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default FAQPage;
